export const graphMargins = 26;
